<template>
<div id="AssetRequisitionCreate" class="fleet-form-main">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="cantAccessPage === true">
            <div class="page-name">
                <span class="page-title" id="purchaseorderHeader" v-if="$route.params.id > 0">Update Asset Requisition</span>
                <span class="page-title" id="purchaseorderHeader" v-else>Add Asset Requisition</span>
                <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="goPreviousPath">
                    <i class="fp-back"> </i> Back
                </button>
            </div>
            <div class="container-fluid">
                <div class="admin-page-content asset-requisition-crud">
                    <section class="internal-container border-top-table-fl">
                        <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="AssetRequisitionForm">
                            <div class="form-row row-cols-md-4 row-cols-1">
                                <div v-if="$route.params.id > 0" class="col form-group pt-md-4">
                                    <label class="control-label" for="name">Requisition:</label>
                                    <span class="">{{vehicle_aquisition}}</span>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label require" for="ordering_location_id">Ordering Facility:</label>
                                    <v-select v-model="ordering_location_id" name="ordering_location_id" placeholder="Select Location." label="text" :options="locationArr">
                                    </v-select>
                                    <div class="field-error">{{ ordering_location_error_msg }}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label require" for="assigned_location_id">Assigned Facility:</label>
                                    <v-select v-model="assigned_location_id" name="assigned_location_id" placeholder="Select Location." label="text" :options="locationArr">
                                    </v-select>
                                    <div class="field-error">{{ assigned_location_error_msg }}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label require" for="ship_to_location_id">Ship To Facility:</label>
                                    <v-select v-model="ship_to_location_id" name="ship_to_location_id" placeholder="Select Location." label="text" :options="locationArr">
                                    </v-select>
                                    <div class="field-error">{{ ship_to_location_error_msg }}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label require" for="delivery_date">Estimated Delivery Date:</label>
                                    <div class="input-group">
                                        <date-picker placeholder="MM/DD/YYYY" id="delivery_date" name="delivery_date" v-model="delivery_date" :config="optionsDate"></date-picker>
                                        <label for="delivery_date" class="fp-calendar input-calender-icon"></label>
                                    </div>
                                    <div class="field-error">{{ delivery_date_error_msg }}</div>
                                </div>
                                <!-- <div class="col form-group">
                                    <label class="control-label" for="delivery_date">Estimated Delivery Date:</label>
                                    <div class="input-group">
                                        <date-picker placeholder="MM/DD/YYYY" id="estimated_delivery_date" name="estimated_delivery_date" v-model="estimated_delivery_date" :config="optionsDate"></date-picker>
                                        <label for="estimated_delivery_date" class="fp-calendar input-calender-icon"></label>
                                    </div>
                                    <div class="field-error">{{ est_delivery_date_error_msg }}</div>
                                </div> -->
                                <!-- <div class="col form-group">
                                    <label class="control-label" for="vendor_id">Sales Person:</label>
                                    <v-select v-model="sales_person_id" name="sales_person_id" id="sales_person_id" label="text"  :options="requisitionRepresentativeArr" placeholder="Select User" >
                                    </v-select>
                                    <div class="field-error">{{ sales_person_error_msg }}</div>
                                </div> -->
                                <div class="col form-group">
                                    <label class="control-label require" for="vendor_id">Pool:</label>
                                    <v-select v-model="asset_pool_id" name="asset_pool_id" id="asset_pool_id" label="text" :options="assetPoolArr" placeholder="Select Asset-Pool.">
                                        <template slot="no-options">
                                            Search Asset Pool...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <div class="field-error">{{ asset_pool_error_msg }}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label" for="customer_id">Customer:</label>
                                    <v-select v-model="customer_id" name="customer_id" :disabled="isDisableCustomerId"
                                            label="text" :filterable="false" :options="customerArr"
                                            @search="onSearchCustomer"
                                            placeholder="Select Customer" class="custom-ci-auto-search">
                                        <template slot="no-options">
                                            Search Customer...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                            {{ option.text }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                            {{ option.text }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <div class="field-error">{{ customer_error_msg }}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label require" for="vehicle_type_id">Equipment Type:</label>
                                    <v-select v-model="vehicle_type_id" name="vehicle_type_id" placeholder="Select Equipement Type."
                                                label="text"
                                                :options="vehicletypeArr">
                                    </v-select>
                                    <div class="field-error">{{vehicle_type_error_msg}}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label" for="gcw">GCW:</label>
                                    <input type="text" v-model="gcw" id="gcw" name="gcw" placeholder="Enter GCW" class="form-control">
                                    <div class="field-error">{{gcw_error_msg}}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label require" for="gcw">Licenced GVW:</label>
                                    <input type="text" v-model="gvw" id="gvw" name="gvw" placeholder="Enter GVW" class="form-control">
                                    <div class="field-error">{{gvw_error_msg}}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label" for="spec_reference">Specification Reference:</label>
                                    <input type="text" v-model="spec_reference" id="spec_reference" name="spec_reference" placeholder="Enter Specification Reference" class="form-control">
                                    <div class="field-error">{{spec_reference_error_msg}}</div>
                                </div>
                                <!-- <div class="col form-group">
                                    <label class="control-label" for="engine_family">Engine Family:</label>
                                    <input type="text" v-model="engine_family" id="engine_family" name="engine_family" placeholder="Enter Engine" class="form-control">
                                    <div class="field-error">{{engine_family_error_msg}}</div>
                                </div> -->
                            </div>
                            <hr class="light-hr"/>
                                <div class="purchase-order-create-main table-responsive-sm">
                                    <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                        <thead>
                                            <tr class="table-primary">
                                                <th scope="col" class="require" width="10%">Asset Make</th>
                                                <th scope="col" class="require" width="10%">Asset Model</th>
                                                <th scope="col" class="require" width="30%">Description</th>
                                                <th scope="col" class="require">Year</th>
                                                <th scope="col" class="require">Qty</th>
                                                <th scope="col" class="require">Price</th>
                                                <th scope="col" class="require">Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <v-select v-model="vehicle_manufacturer_id" name="vehicle_manufacturer_id" placeholder="Select Manufacturer."
                                                            label="text"
                                                            :options="manufacturerArr">
                                                    </v-select>
                                                    <div class="field-error">{{manufacturer_error_msg}}</div>
                                                </td>
                                                <td>
                                                    <v-select v-model="vehicle_model_id" name="vehicle_model_id" placeholder="Select Model."
                                                            label="text"
                                                            :options="modelArr">
                                                    </v-select>
                                                    <div class="field-error">{{model_error_msg}}</div>
                                                </td>
                                                <td>
                                                    <input type="text" v-model="description"
                                                     id="description" name="description" placeholder="Description" class="form-control">
                                                    <div class="field-error">{{desc_error_msg}}</div>
                                                </td>
                                                <td>
                                                    <input type="text" v-model="year" id="year" name="year" placeholder="Year" class="form-control" @keypress="isIntegerCheck($event)">
                                                    <div class="field-error">{{year_error_msg}}</div>
                                                </td>
                                                <td>
                                                    <input type="text" placeholder="Quantity" v-model="quantity" name="quantity" v-on:keyup="calculateAmount($event)" @keypress="isNumberCheck($event)" id="quantity" class="form-control text-right">
                                                    <div class="field-error">{{quantity_error_msg}}</div>
                                                </td>
                                                <td>
                                                    <input type="text" placeholder="Price"
                                                    v-model="unit_price"
                                                    @input="validatePriceInput($event)"
                                                    v-on:keyup="calculateAmount($event)"
                                                    @keypress="isNumberCheck($event)"
                                                    name="unit_price" class="form-control text-right"
                                                    @blur="unit_price = leaveFocus($event)"
                                                    @focus="unit_price = enterVal($event)">
                                                    <div class="field-error">{{unit_price_error_msg}}</div>
                                                </td>
                                                <td>
                                                    <input type="text" disabled placeholder="Amount" v-model="amount" id="amount"
                                                    name="amount" class="form-control text-right">
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <!-- <div class="row">
                                    <div class="col-xs-12 col form-group col-md-4 col-lg-4 pull-right">
                                        <div class="btm-order-total-section">
                                            <p>
                                                <span class="order-title"> Sub Total: </span>
                                                <span class="order-des"> ${{sub_total}} </span>
                                            </p>
                                            <p>
                                                <span class="order-title"> Total: </span>
                                                <span class="order-des"> ${{total}} </span>
                                            </p>
                                        </div>
                                    </div>
                                </div> -->
                                <div class="form-row">
                                    <div class="col form-group">
                                        <div class="alert alert-warning hide" id="alertError">
                                            <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                            <strong id="errorMsg" class="error"></strong>
                                        </div>
                                    </div>
                                </div>

                                <div class="btn-groups">
                                    <button type="button" :disabled='isDisableStore' v-if="$route.params.id > 0" id="CreateAssetRequisitionBtn" class="btn btn-primary" v-on:click.prevent="CreateAssetRequisition">
                                        <i class="fp-reload"> </i> Update
                                    </button>




                                    <button type="button" :disabled='isDisableStore' v-else id="CreateAssetRequisitionBtn" class="btn btn-primary" v-on:click.prevent="CreateAssetRequisition">
                                        <i class="fp-save"> </i> Save
                                    </button>

                                    <button type="button" :disabled='isDisableStore' v-if="$route.params.id == undefined" id="CreateAssetRequisitionAndPOBtn" class="btn btn-primary" v-on:click.prevent="CreateAssetRequisition(flag='Save and Create PO')">
                                        <i class="fp-save"> </i> Save and Create PO
                                    </button>

                                    <button type="button" :disabled='isDisableStore' v-if="$route.params.id == undefined" id="createAndContinueAssetRequisitionBtn" class="btn btn-tertiary" v-on:click.prevent="CreateAssetRequisition(flag='Save and Continue')">
                                        <i class="fp-save-continue"> </i> Save and Continue
                                    </button>

                                    <button type="button" id="CancelAssetRequisitionBtn" class="btn btn-tertiary" v-on:click.prevent="goPreviousPath">
                                        <i class="fp-close"> </i> Cancel
                                    </button>

                                </div>

                            </form>

                    </section>
                </div>
            </div>
        </template>
        <template v-else-if="cantAccessPage === false">
            <div class="col-md-12">
                <div class="error-template">
                    <h1>
                        Oops!</h1>
                    <h2>
                        403 </h2>
                    <div class="error-details">
                        Sorry!, You don't have permission to access this page.
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <loading-content></loading-content>
        </template>
        <app-footer></app-footer>
    </div>
</div>
</template>



<script>
import Vue from "vue";

import EventBus from "../event-bus";
import {commonMixins} from '../../mixins/commonMixins';
import {contractMixins} from '../../mixins/contractMixins';


var contex;


export default {
    name: "AssetRequisitionCreate",
    metaInfo() {
        return {
            title: (this.$route.params.id > 0)? "Update Asset Requisition | " +process.env.COPYRIGHT_NAME : "Create Asset Requisition | " +process.env.COPYRIGHT_NAME
        }
    },

    mixins: [commonMixins, contractMixins],
    data: () => ({
        isDisableStore: false,
        isEdit: false,
        permissions: [],
        cantAccessPage: "",
        po_number: "",
        vehicle_aquisition:'',
        vendor_id: null,
        vendorArr: [],
        ordering_location_id: null,
        assigned_location_id: null,
        ship_to_location_id: null,
        delivery_date: "",
        // estimated_delivery_date: "",
        est_delivery_date_error_msg:'',
        locationArr: [],
        status: "open",
        open_status: "open",
        closed_status: "closed",
        reserved__status: "reserved",
        openCheckBox: "1",
        closedCheckBox: "1",
        reservedCheckBox: "1",
        loading: false,
        // po_number_error_msg: "",
        assigned_location_error_msg: "",
        ordering_location_error_msg: "",
        ship_to_location_error_msg: "",
        delivery_date_error_msg: "",
        showCharges: false,
        vehicle_manufacturer_id:'',
        chargesArr: [],
        type: "",
        status_error_msg: "",
        type_error_msg: "",
        amount_error_msg: "",
        total_charge_error_msg: "",
        optionsDate: {
            format: 'MM/DD/YYYY',
            useCurrent: false,
        },
        rows: [],
        modelcodeArr: [],
        assetPoolArr: [],
        sub_total: 0,
        total: 0,
        total_tax: 0,
        notes: "",
        customerArr: [],
        userArr: [],
        customer_id: null,
        isDisableCustomerId: false,
        customer_error_msg: "",
        sales_person_id: null,
        sales_person_error_msg: "",
        wo_amount_error_msg:'',
        notes_error_msg:'',
        work_oid:0,
        manufacturerArr:[],
        model_code: null,
        model_error_msg: "",
        year: "",
        year_error_msg: "",
        quantity: 0,
        quantityEdit: true,
        quantity_error_msg: "",
        asset_pool_id: null,
        asset_pool_error_msg: "",
        unit_price: 0,
        unit_priceEdit: true,
        unit_price_error_msg: "",
        tax_percentage: 0,
        tax_percentage_error_msg: "",
        tax_amount: 0,
        tax_amount_error_msg: "",
        amount: 0,
        description: "",
        desc_error_msg: "",
        vehicletypeArr:[],
        vehicle_type_error_msg:'',
        vehicle_type_id:'',
        spec_reference_error_msg:'',
        spec_reference:'',
        engine_family:'',
        engine_family_error_msg:'',
        gvw:'',
        gcw:'',
        gvw_error_msg:'',
        gcw_error_msg:'',
        vehicle_model_id:'',
        modelArr:[],
        manufacturer_error_msg:'',
        requestInProgress:false,
    }),

    watch: {

        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_asset_requisition') {
                        self.cantAccessPage = true;
                    }
                }
            }

        },
        vehicle_manufacturer_id: function(vehicle_manufacturer_id) {

            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");

            if(self.vehicle_manufacturer_id == null || self.vehicle_manufacturer_id == ""){
                self.vehicle_model_id = null;
                self.modelArr = [];
                return;
            }

            $.ajax({
                url: process.env.ROOT_API + "/assetmodel/search",
                type: "GET",
                headers: this.ajxHeaders,
                crossDomain: true,
                dataType:"json",
                data:{
                    id:vehicle_manufacturer_id.value,
                },
                success: function (data) {
                    //if data is edit than dont make model id blank
                    if ( !self.isEdit ) {
                        // self.vehicle_model_id = "";
                    }
                    self.isEdit = false;
                    if (data.status == "success") {

                        if(self.is_group_call==true){
                            self.is_group_call=false;
                        }else{

                            if ( !segments[3]){

                                self.vehicle_model_id = null;

                            }
                            self.modelArr = data.content.vehiclemodels;

                        }
                    }

                },
                error: function (jqXHR, exception) {
                    self.Registerbtn = "Register";
                    self.generateStatusCodeMessage(jqXHR,true,'asset-manufacture-search')
//                    if (jqXHR.status == 0) {
//                        self.error = "Remote server cannot be reached";
//                    } else {
//                    //redirect to login page if user not authenticated
//                    if (jqXHR.status == 401) {
//                        //clear previous data
//                        localStorage.removeItem("user_obj");
//                        localStorage.removeItem("tkn");
//
//                        self.$router.push("/");
//                    }
//                        self.error = jqXHR.responseJSON.message;
//                    }
                }
            });
        },
        description: function(description) {
          var self = this;
          self.description = self.capitalize(description);
        }
    },
    created: function () {

    },
    mounted: function () {
        var self = this;
        // self.statusValue = 1;
        var path = window.location.pathname;
        var segments = path.split("/");

        var userObj = JSON.parse(localStorage.getItem("user_obj"));
        if (userObj != null) {
            if (userObj.roles.length > 0) {
                for(var i = 0; i < userObj.roles.length; i++){
                    if (userObj.roles[i].name == 'customer') {
                        //self.titleCase(name + " (" + code + ")")
                        self.customer_id = {
                            value: userObj.customer_id,
                            text: self.titleCase(userObj.first_name)
                        };
                        self.isDisableCustomerId = true;
                    }
                }
            // }
            }

            //set LoggedIn user's location as default location....
            if (userObj["location_id"] != null && userObj["location_id"] != '') {
                self.ordering_location_id = {
                    value: userObj["location_id"],
                    text: self.titleCase(userObj["locationName"])
                };
                self.assigned_location_id = {
                    value: userObj["location_id"],
                    text: self.titleCase(userObj["locationName"])
                };
                self.ship_to_location_id = {
                    value: userObj["location_id"],
                    text: self.titleCase(userObj["locationName"])
                };
            }

            if ( segments[3]){
                self.loadAssetRequisition();
            }

            // // set LoggedIn user as default user....
            // if(userObj["last_name"] != null && userObj["last_name"] != ''){
            //     self.user_id = self.loggedInUser = {value: userObj["id"], text: self.titleCase(userObj["first_name"]) + " " + self.titleCase(userObj["last_name"])};
            // }else{
            //     self.user_id = self.loggedInUser = {value: userObj["id"], text: self.titleCase(userObj["first_name"])};
            // }
        }

        self.getPermissions();
        this.loadFieldData(['location','requisition_representative','vehicle_pool']);
        self.loadVehicleSearchData();
        var path = window.location.pathname;
        var segments = path.split("/");

    },
    beforeMount:function () {
            contex = this;
    },
    methods: {
        // enterVal:function(evt) {
        //   evt = (evt) ? evt : window.event;
        //   console.log("ENTER  ==", evt.target.value);
        //   this.unit_price = evt.target.value;
        //   this.unit_price = evt.target.value.replace(/\,/g,"");
        // },
        // leaveFocus:function(evt) {
        //   evt = (evt) ? evt : window.event;
        //   console.log("focus ==", evt.target.value);
        //   this.unit_price =  this.amountFormat(evt.target.value);
        // },
        amountFormat(amount) {
            const formatter = new Intl.NumberFormat('en-US', {
                minimumFractionDigits:2,
                maximumFractionDigits:2
            });

            return formatter.format(amount);
        },
        AssetRequisitionList:function(){
            var self = this;

            self.$router.push('/asset-requisition/list');
        },

        loadVehicleSearchData() {

            var self = this;
            $.ajax({
                url: process.env.ROOT_API + "/asset/search",
            type: "GET",
                headers: this.ajxHeaders,
                crossDomain: true,
                dataType: 'json',
                success: function (data) {

                    if (data.status == "success") {

                        self.manufacturerArr = data.vehiclemanufacturer;
                        self.vehicletypeArr = data.vehicletypes;
                        self.vehicleownershipArr = data.vehicleownership;
                    }

                },
                error: function (jqXHR, exception) {
                    self.Registerbtn = "Register";

                    self.generateStatusCodeMessage(jqXHR,true,'load-vehicle-search-data')
                }
            });
        },

        CreateAssetRequisition(flag) {
            var self = this;
            var error = false;

            self.assigned_location_error_msg = "";
            self.ordering_location_error_msg = "";
            self.ship_to_location_error_msg = "";
            self.delivery_date_error_msg = "";
            self.status_error_msg = "";
            self.purchase_order_type_error_msg = "";
            self.order_date_error_msg = "";
            self.due_date_error_msg = "";
            self.wo_amount_error_msg = '';
            self.model_error_msg = "";
            self.desc_error_msg = "";
            self.asset_pool_error_msg = "";
            self.unit_price_error_msg = "";
            self.quantity_error_msg = "";
            self.vehicle_type_error_msg = "";
            self.manufacturer_error_msg = "";
            self.year_error_msg = '';

            // if (!self.due_date || self.due_date == null || self.due_date == "") {
            //     self.due_date_error_msg = "Due Date Required.";
            //     error = true;
            // }

            if (!self.assigned_location_id || self.assigned_location_id == null || self.assigned_location_id == "") {
                self.assigned_location_error_msg = "Assigned Location Required.";
                error = true;
            }

            if (!self.ordering_location_id || self.ordering_location_id == null || self.ordering_location_id == "") {
                self.ordering_location_error_msg = "Ordering Location Required.";
                error = true;
            }
            if (!self.ship_to_location_id || self.ship_to_location_id == null || self.ship_to_location_id == "") {
                self.ship_to_location_error_msg = "Ship To Location Required.";
                error = true;
            }
            if (!self.delivery_date || self.delivery_date == null || self.delivery_date == "") {
                self.delivery_date_error_msg = "Delivery Date Required.";
                error = true;
            }

            var checkNumber = /^[0-9]+(\.[0-9]+)?$/;

            if (self.unit_price == null || self.unit_price == 0 || !self.unit_price) {
                self.unit_price_error_msg = "Unit Price is Required.";
                error = true;
            }
            if (self.year == null || self.year == '' || !self.year) {
                self.year_error_msg = "Year is Required.";
                error = true;
            }

            if (self.quantity == null || !self.quantity || self.quantity == 0) {
                self.quantity_error_msg = "Quantity is Required.";
                error = true;
            }

            if (self.description == null || self.description == "") {
                self.desc_error_msg = "Description is Required.";
                error = true;
            }

            if (self.vehicle_model_id == null || !self.vehicle_model_id.value) {
                self.model_error_msg = "Asset Model is Required.";
                error = true;
            }
            if (self.vehicle_manufacturer_id == null || !self.vehicle_manufacturer_id.value) {
                self.manufacturer_error_msg = "Manufacturer is Required.";
                error = true;
            }
            if (self.vehicle_type_id == null || !self.vehicle_type_id.value) {
                self.vehicle_type_error_msg = "Asset Type is Required.";
                error = true;
            }

            if (self.gvw == null || self.gvw == "") {
                self.gvw_error_msg = "Licenced GVW is Required.";
                error = true;
            }


            if (self.asset_pool_id == null || !self.asset_pool_id.value) {
                self.asset_pool_error_msg = "Asset Pool is Required.";
                error = true;
            }

            if (!error) {

                if ( self.requestInProgress == true ) {
                    return;
                }
                self.requestInProgress = true;
                self.loading = true;
                var path = window.location.pathname;
                var segments = path.split("/");

                var typesArr = [];
                var amountArr = [];
                var taxPercentageArr = [];
                var totalChargeArr = [];

                if (segments[3]) {
                    $("#CreateAssetRequisitionBtn").val("Updating ...");
                    $("#CreateAssetRequisitionBtn").prop("disabled", true);
                    $("#CancelAssetRequisitionBtn").prop("disabled", true);
                } else {
                    if (flag == "Save and Continue") {

                        $("#createAndContinueAssetRequisitionBtn").val("Saving ...");
                        $("#CreateAssetRequisitionBtn").prop("disabled", true);
                        $("#createAndContinueAssetRequisitionBtn").prop("disabled", true);
                        $("#CancelAssetRequisitionBtn").prop("disabled", true);

                    } else {

                        $("#CreateAssetRequisitionBtn").val("Saving ...");
                        $("#CreateAssetRequisitionBtn").prop("disabled", true);
                        $("#createAndContinueAssetRequisitionBtn").prop("disabled", true);
                        $("#CancelAssetRequisitionBtn").prop("disabled", true);
                    }
                }

                var fields = $("#AssetRequisitionForm").serializeArray();

                var idx = fields.findIndex(obj => obj.name == 'unit_price');
                if (idx != -1) {
                  fields.push({
                      name: "unit_price",
                      value: fields[idx].value.replace(/\,/g,"")
                  });
                  fields.splice(idx, 1);
                }


                // alert(JSON.stringify(fields));

                if (self.ordering_location_id == null) {
                    fields.push({
                        name: "ordering_location_id",
                        value: ""
                    });
                } else {
                    fields.push({
                        name: "ordering_location_id",
                        value: self.ordering_location_id.value
                    });
                }

                if (self.assigned_location_id == null) {
                    fields.push({
                        name: "assigned_location_id",
                        value: ""
                    });
                } else {
                    fields.push({
                        name: "assigned_location_id",
                        value: self.assigned_location_id.value
                    });
                }
                if (self.vehicle_type_id == null) {
                    fields.push({
                        name: "vehicle_type_id",
                        value: ""
                    });
                } else {
                    fields.push({
                        name: "vehicle_type_id",
                        value: self.vehicle_type_id.value
                    });
                }
                if (self.vehicle_manufacturer_id == null) {
                    fields.push({
                        name: "vehicle_manufacturer_id",
                        value: ""
                    });
                } else {
                    fields.push({
                        name: "vehicle_manufacturer_id",
                        value: self.vehicle_manufacturer_id.value
                    });
                }
                if (self.vehicle_model_id == null) {
                    fields.push({
                        name: "vehicle_model_id",
                        value: ""
                    });
                } else {
                    fields.push({
                        name: "vehicle_model_id",
                        value: self.vehicle_model_id.value
                    });
                }
                if (self.asset_pool_id == null) {
                    fields.push({
                        name: "asset_pool_id",
                        value: ""
                    });
                } else {
                    fields.push({
                        name: "asset_pool_id",
                        value: self.asset_pool_id.value
                    });
                }

                if (self.ship_to_location_id == null) {
                    fields.push({
                        name: "ship_to_location_id",
                        value: ""
                    });
                } else {
                    fields.push({
                        name: "ship_to_location_id",
                        value: self.ship_to_location_id.value
                    });
                }

                if (self.customer_id == null) {
                    fields.push({
                        name: "customer_id",
                        value: null
                    });
                } else {
                    fields.push({
                        name: "customer_id",
                        value: self.customer_id.value
                    });
                }

                // if (self.sales_person_id == null) {
                //     fields.push({
                //         name: "sales_person_id",
                //         value: ""
                //     });
                // } else {
                //     fields.push({
                //         name: "sales_person_id",
                //         value: self.sales_person_id.value
                //     });
                // }

                fields.push({
                    name: "amount",
                    value: self.amount
                });

                fields.push({
                    name: "id",
                    value: segments[3]
                });

                console.log('fields == ', fields);
                $.ajax({
                    url: process.env.ROOT_API + "/asset-requisition/create",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.requestInProgress = false;
                        self.loading = false;
                        if (segments[3]) {
                            $("#CreateAssetRequisitionBtn").val("Update");
                            $("#CreateAssetRequisitionBtn").prop("disabled", false);
                            $("#CancelAssetRequisitionBtn").prop("disabled", false);
                        } else {
                            if (flag == "Save and Continue") {

                                $("#createAndContinueAssetRequisitionBtn").val("Save and Continue");
                                $("#CreateAssetRequisitionBtn").prop("disabled", false);
                                $("#createAndContinueAssetRequisitionBtn").prop("disabled", false);
                                $("#CancelAssetRequisitionBtn").prop("disabled", false);

                            } else {

                                $("#CreateAssetRequisitionBtn").val("Save");
                                $("#CreateAssetRequisitionBtn").prop("disabled", false);
                                $("#createAndContinueAssetRequisitionBtn").prop("disabled", false);
                                $("#CancelAssetRequisitionBtn").prop("disabled", false);

                            }
                        }
                        if (data.status == "success") {

                          console.log("data ==", data);

                            if (flag == "Save and Continue") {

                                $("#AssetRequisitionForm").trigger("reset");

                                self.ordering_location_id = null;
                                self.assigned_location_id = null;
                                self.ship_to_location_id = null;
                                self.delivery_date = "";
                                self.customer_id = null;
                               // self.sales_person_id = null;
                                self.vendor_id = null;
                                self.attention = "";
                                self.notes = "";
                                self.model_code = "";
                                self.vehicle_type_id = "";
                                self.vehicle_model_id = null;
                                self.year = "",
                                self.quantity = 0,
                                self.asset_pool_id = null,
                                self.unit_price = 0,
                                self.unit_price_error_msg = "",
                                self.amount = 0,
                                self.gcw = '';
                                self.gvw = '';
                                self.spec_reference = '';
                                self.engine_family = '';
                                self.vehicle_manufacturer_id = null;
                                self.description = '';

                                self.sub_total = 0;
                                self.sub_total.toFixed(2);

                                self.total = 0;


                            } else if (flag == "Save and Create PO") {

                              console.log("ID ===",data.content.id);

                              self.$router.push({ name: 'VendorPurchaseOrderCreate', params:{requisitionId: data.content.id, redirectFrom: 'AssetRequisition'}})



                            } else {
                                self.$router.push("/asset-requisition/list/");
                            }

                        } else {
                            if (data.content.length > 0) {
                                var err = "";
                                for (var i = 0; i < data.content.length; i++) {
                                    err += data.content[i] + "<br>";
                                }
                                $("#errorMsg").html(err);
                                $(".alert-warning").toggleClass("show");
                                setTimeout(function () {
                                    $(".alert-warning").removeClass("show");
                                    $(".alert-warning").addClass("hide");
                                }, 10000);
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.requestInProgress = false;
                        if (segments[3]) {
                            $("#CreateAssetRequisitionBtn").val("Update");
                            $("#CreateAssetRequisitionBtn").prop("disabled", false);
                            $("#CancelAssetRequisitionBtn").prop("disabled", false);
                        } else {
                            if (flag == "Save and Continue") {

                                $("#PurchaseOrderForm").trigger("reset");
                                $("#createAndContinueAssetRequisitionBtn").val("Save and Continue");
                                $("#CreateAssetRequisitionBtn").prop("disabled", false);
                                $("#createAndContinueAssetRequisitionBtn").prop("disabled", false);
                                $("#CancelAssetRequisitionBtn").prop("disabled", false);

                            } else {

                                $("#CreateAssetRequisitionBtn").val("Save");
                                $("#CreateAssetRequisitionBtn").prop("disabled", false);
                                $("#createAndContinueAssetRequisitionBtn").prop("disabled", false);
                                $("#CancelAssetRequisitionBtn").prop("disabled", false);

                            }
                        }
                        self.generateStatusCodeMessage(jqXHR,true,'asset-requisition-create')

                    }
                });
            }else{
                self.errorValidationFocus();
            }
        },

        loadAssetRequisition() {
            var path = window.location.pathname;
            var segments = path.split("/");
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/asset-requisition/" + segments[3],
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    console.log(data);

                    if (data.status == "success") {

                        self.delivery_date = data.content.required_delivery_date;
                        // self.estimated_delivery_date = data.content.estimated_delivery_date;
                        if (data.content.assigned_loc_id == null) {
                            self.assigned_location_id = null;
                        } else {
                            self.assigned_location_id = {
                                value: data.content.assigned_loc_id,
                                text: self.titleCase(data.content.assigned_loc_name + " (" + data.content.assigned_loc_code +
                                    ")")
                            };
                        }

                        if (data.content.ordering_loc_id == null) {
                            self.ordering_location_id = null;
                        } else {
                            self.ordering_location_id = {
                                value: data.content.ordering_loc_id,
                                text: self.titleCase(data.content.ordering_loc_name + " (" + data.content.ordering_loc_code +
                                    ")")
                            };
                        }

                        if (data.content.ship_loc_id == null) {
                            self.ship_to_location_id = null;
                        } else {
                            self.ship_to_location_id = {
                                value: data.content.ship_loc_id,
                                text: self.titleCase(data.content.ship_loc_name + " (" + data.content.ship_loc_code + ")")
                            };
                        }

                        if ((data.content.customer_id) != null) {
                            var name = (data.content.cust_name != null) ? data.content.cust_name : "";
                            var code = (data.content.cust_code != null) ? data.content.cust_code : "";

                            self.customer_id = {
                                value: data.content.customer_id,
                                text: self.titleCase(name + " (" + code + ")")
                            };
                        } else {
                            self.customer_id = null;
                        }

                        // if ((data.content.sales_id) != null) {
                        //     // var firstname = (data.content.sales_firstname != null) ? data.content.sales_firstname : "";
                        //     // var lastname = (data.content.sales_lastname != null) ? data.content.sales_lastname : "";
                        //     self.sales_person_id = {
                        //         value: data.content.sales_id,
                        //         text: self.titleCase(data.content.sales_person_name)
                        //     };
                        // } else {
                        //     self.sales_person_id = null;
                        // }

                        if (data.content.manufacturerId == null) {
                            self.vehicle_manufacturer_id = null;
                        } else {
                            self.vehicle_manufacturer_id = {
                                value: data.content.manufacturerId,
                                text: self.titleCase(data.content.manufacturerName + " (" + data.content.manufacturerCode + ")")
                            };
                        }

                        if (data.content.modelId == null) {
                            self.vehicle_model_id = null;
                        } else {
                            self.vehicle_model_id = {
                                value: data.content.modelId,
                                text: self.titleCase(data.content.modelName + " (" + data.content.modelCode + ")")
                            };
                        }

                        if (data.content.poolId == null) {
                            self.asset_pool_id = null;
                        } else {
                            self.asset_pool_id = {
                                value: data.content.poolId,
                                text: self.titleCase(data.content.poolCode + " | " + data.content.poolName)
                            };
                        }

                        if (data.content.typeId == null) {
                            self.vehicle_type_id = null;
                        } else {
                            self.vehicle_type_id = {
                                value: data.content.typeId,
                                text: self.titleCase(data.content.typeName + " (" + data.content.typeCode + ")")
                            };

                        }

                        self.vehicle_aquisition = data.content.requisition_no;
                        self.description = data.content.description;
                        self.year = data.content.year;
                        self.gvw = data.content.licenced_gvw;
                        self.gcw = data.content.gcw;
                        self.spec_reference = data.content.spec_reference;
                        //self.engine_family = data.content.engine_family;
                        self.quantity = data.content.quantity;
                        self.unit_price = self.amountFormat(data.content.unit_price);

                        self.calculateTaxSubTotal();
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'asset-requisition-load')

                }
            });
        },


        calculateAmount($event) {
            // alert(index);
            var self = this;
            if (self.quantity == 0 || self.unit_price == 0 || self.quantity == null ||
                self.unit_price == null) {
                self.tax_percentage = 0;
            }
            self.calculateTaxSubTotal();

        },
        taxPercentage($event) {
            var self = this;

            if (self.quantity && self.unit_price) {
                self.calculateTaxSubTotal();
            } else {
                self.tax_percentage = "";
                if (self.quantity == null || !self.quantity) {
                    self.quantity_error_msg = "Quantity is Required.";
                }
                if (self.unit_price == null || !self.unit_price) {
                    self.unit_price_error_msg = "Unit Price is Required.";
                }
            }
        },
        onSearchCustomer(search, loading) {
            var self = this;
            if (search.length > 2) {
                loading(true);
                self.searchField(loading, search, 'customer', '');
            }
        },
        onSearchUser(search, loading) {
            var self = this;
            if (search.length > 0) {

                loading(true);
                self.searchField(loading, search, 'user', '');
            }
        },
        onSearchModel(search, loading) {
            var self = this;
            if (search.length > 2) {

                loading(true);
                self.searchField(loading, search, 'vehicle_model', '');
            }
        },
        onSearchManufacturer(search, loading) {
            var self = this;
            if (search.length > 2) {

                loading(true);
                self.searchField(loading, search, 'vehicle_manufacturer', '');
            }
        },
        onSearchAssetPool(search, loading) {
            var self = this;
            if (search.length > 1) {
                loading(true);
                self.searchField(loading, search, 'vehicle_pool', '');
            }
        },
        onSearchComponent(search, loading) {
            var self = this;
            if (search.length > 1) {
                loading(true);
                self.searchField(loading, search, 'component', '');
            }
        },

        onSearchVendor(search, loading) {
            var self = this;
            if (search.length > 2) {

                loading(true);
                self.searchField(loading, search, 'vendor', '');
            }
        },

        calculateTaxSubTotal() {
            var self = this;

            if( String(self.quantity).includes(':')){

                var quant = self.quantity.split(':');
                self.quantity = quant[0];
            }

            // console.log(self.quantity * parseFloat());
            // self.unit_price = self.removeFormat(self.unit_price);
            if ((self.quantity != "" && self.quantity != ".") && (self.unit_price != "" && self.unit_price != ".")) {
                self.amount = self.quantity * parseFloat(self.removeFormat(self.unit_price));
                self.tax_amount = (self.amount * self.tax_percentage) / 100;
                // alert(self.tax_amount);

                if ( self.tax_amount){

                    self.amount = parseFloat(self.amount + self.tax_amount);
                }else{

                    self.amount = parseFloat(self.amount);
                }

                self.amount = self.amount.toFixed(2);
                self.sub_total = self.amount;
                self.total = self.amount;
            }else{
                self.amount = 0;
                self.amount = self.amount.toFixed(2);
                self.sub_total = self.amount;
                self.total = self.amount;
            }

        },

        titleCase(str) {
            if (str == null) {
                return;
            } else {
                var value = str.toString()
                return value.charAt(0).toUpperCase() + value.slice(1)
            }
        },

        isNumberCheck: function (evt) {
            var self = this;
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && (charCode !== 46 || evt.target.value.indexOf(
                    '.') != -1)) {
                evt.preventDefault();
            } else {
              if(self.unit_priceEdit) {
                return true;
              } else {
                evt.preventDefault();
              }
              return true;
            }
        },
        backToList: function(){
            var self = this;

            self.$router.push('/asset-requisition/list');
        }
    }
};

EventBus.$on('price-exide', function (value) {
  if(value) {
    contex.unit_priceEdit = false;
    contex.unit_price_error_msg = "Amount Value Exide";
    contex.isDisableStore = true;
  } else {
    contex.unit_priceEdit = true;
    contex.unit_price_error_msg = "";
    contex.isDisableStore = false;
  }
});
</script>

<style scoped>
/* disable v-select of Asset on Edit*/
.js-example-disabled {
    pointer-events: none;
    color: #bfcbd9;
    cursor: not-allowed;
    background-image: none;
    background-color: #eef1f6;
    border-color: #d1dbe5;
}
</style>



// WEBPACK FOOTER //
// src/components/asset/AssetrequisitionCreate.vue